import React from 'react'

type Props = {
  id: string
  text: string
  selected: string
  onChange: (id: string) => void
}

function FeedbackOption({ id, text, selected, onChange }: Props) {
  return (
    <div
      style={{
        textAlign: 'start',
        display: 'flex',
        textTransform: 'uppercase',
        border: '2px solid var(--lighter-blue)',
        borderRadius: '2rem',
        padding: '0.3rem 2.7rem',
        overflowWrap: 'break-word',
        fontWeight: 500,
        fontSize: '1.4rem',
        margin: '1rem',
        cursor: 'pointer',
      }}
    >
      <input
        required
        type="radio"
        id={`feedbackType${id}`}
        name="feedbackType"
        checked={selected === id}
        onChange={() => onChange(id)}
      />
      <label htmlFor={`feedbackType${id}`} style={{ lineHeight: '1' }}>
        {text}
      </label>
    </div>
  )
}

export default FeedbackOption
